<template>
  <div class="page-con">
    <div class="list-box clearfix">
      <!--      <div v-if="audit_status === 2 || audit_status === 4"-->
      <!--           style="margin-left:200px;color: #d72c2c;font-size: 20px;font-weight: 600">-->
      <!--        审核通知：{{formData.remark}}-->
      <!--      </div>-->
      <vxe-form
          ref="xForm"
          class="my-form2"
          title-align="right"
          title-width="300"
          :data="formData"
          style="padding-right: 100px">
        <vxe-form-item title="姓名：" field="realName" span="24">
          <div>{{ formData.realName }}</div>
        </vxe-form-item>
        <vxe-form-item title="手机号：" field="regisiterNum" span="24">
          <div>{{ formData.regisiterNum }}</div>
        </vxe-form-item>
        <vxe-form-item title="身份证号码：" field="idcardNum" span="24">
          <div>{{ formData.idcardNum }}</div>
        </vxe-form-item>
        <vxe-form-item title="身份证：" field="idCard" span="24">
          <template>
            <div v-if="formData.idcardFrontUrl" style="display: flex;align-items: center;">
              <div class="uploadPic" ref="imgbox">
                <viewer>
                  <img class="upload-img" :src="formData.idcardFrontUrl"/>
                </viewer>
              </div>
            </div>
            <div v-if="formData.idcardBackUrl" style="display: flex;align-items: center;margin-top: 20px">
              <div class="uploadPic">
                <viewer>
                  <img class="upload-img" :src="formData.idcardBackUrl"/>
                </viewer>
              </div>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item align="center" span="24" v-if="audit_status === 2">
          <template v-slot>
            <div style="margin-left:200px;color: #f10404;display: flex;align-items: center;">
              <img style="width: 20px;height: 20px;" src="@/assets/images/common/warnInfo.png"/>
              <span style="margin-left: 10px;">{{ errMsg }}</span>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template v-slot>
            <vxe-button type="submit" status="primary" @click="close">关 闭</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
  </div>
</template>
<script>
import auth from "@/utils/auth";
import {showLoading, hideLoading} from "@/utils/util";
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import Auth from "@/utils/auth.js";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import Vue from "vue";

Vue.use(Viewer);

export default {
  name: 'perAuthentication',
  props: {
    isClient: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [getAuthOrization],
  data() {
    let userInfoValue = {};
    if (Auth.isLogin()) {
      userInfoValue = Auth.getAuth();
    }
    return {
      userInfoValue,
      errMsg: '',
      formData: {
        idcardBackUrl: null, //身份证背面图地址
        idcardFrontUrl: null, //身份证正面图地址
        idcardNum: null, //身份证号码
        regisiterNum: null, //手机号
        realName: null, //实名
      },
      readOnly: false,
      userId: '',
      audit_status: 1 //认证状态1.已提交/待审核 2.未通过 3.通过 4.已过期
    }
  },
  methods: {
    init(id) {
      this.userId = id;
      this.queryUserAuth();
    },
    async queryUserAuth() {
      showLoading();
      let obj = this.isClient ? {
        userIdClient: this.userId
      } : {
        userId: this.userId
      }
      let res = await $api.authUser.request("queryUserAuth", obj);
      hideLoading();
      if (res.status === 1) {
        let data = res.data;
        this.audit_status = data.auditStatus;
        this.formData.regisiterNum = data.regisiterNum
        this.formData.idcardBackUrl = data.idcardBackUrl;
        this.formData.idcardFrontUrl = data.idcardFrontUrl;
        this.formData.idcardNum = data.idcardNum;
        this.formData.realName = data.realName;
        if (data.remark) {
          this.formData.remark = data.remark;
        }
        if (this.audit_status === 2) {
          let authSource = '';
          let err = '未知';
          if (data.authSource === 1) {
            authSource = '平台'
            err = data.remark;
          } else if (data.authSource === 2) {
            authSource = '法大大'
            err = data.statusDesc;
          } else if (data.authSource === 3) {
            authSource = '网易'
            if (data.yidunStatus === 500) {
              err = data.yidunError;
            } else {
              switch (data.yidunReasonType) {
                case 2 :
                  err = '认证不一致';
                  break;
                case 3 :
                  err = '该手机号查询无记录';
                  break;
                case 4 :
                  err = '认证信息有误';
                  break;
                case 5 :
                  err = '号码状态异常（空号、停机等）';
                  break;
                case 6 :
                  err = '解析手机号运营商失败';
                  break;
                case 7 :
                  err = '其他出错，请联系客服';
                  break;
              }
            }
          }
          this.errMsg = '未通过原因(' + authSource + '):' + err;
        } else {
          this.errMsg = '';
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>
<style scoped>
.picTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.picTitle img {
  width: 140px;
  height: 100px;
  border: 1px dashed black
}

.picTitle span {
  font-size: 14px;
  margin-top: 8px;
}

.uploadPic {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.uploadPic .ivu-upload {
  width: 140px;
  height: 100px;
}

.upload-div {
  width: 140px;
  height: 100px;
  border: 1px dashed black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-img {
  width: 140px;
  height: 100px;
  border: 1px dashed black;
}

.upload-title {
  color: rgb(153, 153, 153);
  font-size: 14px;
  margin-top: 8px;
}

.remark {
  font-size: 14px;
  color: #CCCCCC;
  margin-top: 8px;
}
</style>